import MenuError from './MenuError';

export default function Component(props) {
    return <MenuError {...props} />;
}
